import React from 'react'
import { useParams } from 'react-router'

import { landAxios } from '@Root/utils/landAxios'
import VAC_AlarmPopup from '@Components/VAC/alarm/VAC_AlarmPopup'
import usePopup from '@Hooks/popup/usePopup'
import { POPUP_TYPE } from '@Root/contants/popup'

const AlarmTradeCompletePopup: React.FC = () => {
  const { popup, changeInit, changePopupData } = usePopup()
  const { articleNo: encryptedArticleNo } = useParams<{ articleNo: string }>()

  const handleClickConfirm = (evt: React.SyntheticEvent) => {
    evt.preventDefault()
    evt.stopPropagation()

    landAxios
      .post(`/article/owner/trade/complete/${encryptedArticleNo}/TRAD_CMPL/check_ok`)
      .then((res) => {
        if (res.data === 'SUCCESS') {
          changePopupData({ key: POPUP_TYPE.ALARM_EXPOSURE_END_BY_TRADE_COMPLETE })
        } else {
          changePopupData({ key: POPUP_TYPE.ALARM_REQUEST_FAIL })
        }
      })
      .catch(() => {
        changePopupData({ key: POPUP_TYPE.ALARM_REQUEST_FAIL })
      })
  }

  const handleClickClose = (evt: React.SyntheticEvent) => {
    evt.preventDefault()
    evt.stopPropagation()

    changeInit()
  }

  const popupProps = {
    popupList: {
      [popup.key]: { ...popup, confirmText: '확인', closeButton: true, handleClickClose, handleClickConfirm },
    },
  }

  return (
    <>
      <VAC_AlarmPopup popupList={popupProps.popupList} isHidden={false} />
    </>
  )
}

export default AlarmTradeCompletePopup
